import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { IListTarifa } from '../../models/cotizador/IListTarifa';
import { IDataTarifa } from '../../models/cotizador/IDataTarifa';
import { BodyResponse } from '../../models/cotizador/BodyResponse';
import { ApiEndpoint } from './api.endpoint';
import {
  CampaniaRequest,
  ContractRequest,
  ModeloCotizacion,
  QuotationPeopleRequest,
} from '../../models/cotizador/request/model.data.request';
import {
  campanias,
  ContratPeopleResponse,
  documentType,
  QuotationPeopleResponse,
  ContratosActivos,
  regional,
  tiposDeAsesor,
  ciudadesCem,
} from '../../models/cotizador/response/model.data.response';
import {
  ModelDefaultResponse,
  ModelDefaultResponseCampania,
} from '../../models/cotizador/response/model.default.response';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import {
  LiquidacionColectivoRequest,
  LiquidacionColectivoResponse,
} from '../../models/cotizacion-colectivo/liquidacion-colectivo.model';
import {sectoresCIIU } from '../../models/cotizador/response/model.data.response';

export interface GeneralResponse<T> {
  status: boolean;
  codeStatus: string;
  message: string;
  data: T;
  errorMessage: string;
}

export interface BrochureProgramaRequest {
  programas: string[];
}

export interface BrochureProgramaResponse {
  idBrochure: number;
  lineaNegocio: string;
  programa: string;
  nombreArchivo: string;
  mimeType: string;
  pdfBase64: string;
}

@Injectable({
  providedIn: 'root',
})

export class NetworkingQuotation {
  networkingOutput: any;
  responseEnviar: any;

  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.DOCUMENTOS_TIPOS_DOCUMENTOS}`;
  private readonly UrlContratos = `${environment.HOST}${URL_MAP.API.USUARIO_ACTIVO_CONTRATOS}`;
  private readonly urlCodigo_Asesor = `${environment.HOST}${URL_MAP.API.COTIZADOR_CODIGO_ASESOR}`;
  private readonly urlDatosxEmpresa = `${environment.HOST}${URL_MAP.API.DATOS_X_EMPRESA}`;
  private apiAfilmed = `${environment.HOST}${URL_MAP.API.AFILMED}`;
  private apiAfeCotizadorUrl = `${environment.HOST}${URL_MAP.API.AFE}`;
  private apiAfeParms = `${environment.HOST}${URL_MAP.API.CONSULTARANEXOS}`;
  private readonly apiAfeLiquidacionColectivo = `${environment.HOST}${URL_MAP.API.GUARDAR_LIQUIDACION_COLECTIVO}`;
  private readonly apiPdfCotizacionColectivo = `${environment.HOST}${URL_MAP.API.PDF_COTIZACION_COLECTIVO}`;
  private readonly apiCotizacion = `${environment.HOST}${URL_MAP.API.COTIZADOR_COTIZACION}`;
  private readonly apiObtenerLiquidacionColectivo = `${environment.HOST}${URL_MAP.API.OBTENER_LIQUIDACION_COLECTIVO}`;
  private readonly apiCarnetPrograma = `${environment.HOST}${URL_MAP.API.CONSULTAR_PROGRAMAS_LINEA_NEGOCIO}`;
  private readonly apiCotizacionActiva = `${environment.HOST}${URL_MAP.API.CONSULTAR_COTIZACION_ACTIVA}`; 
  private readonly apiSectores = `${environment.HOST}/cotizador/api`;
  private readonly apiBrochuresProgramas = `${environment.HOST}/cotizador/api/brochures/programas`;

  constructor(
    private httpClient: HttpClient,
    private apiEndpoint: ApiEndpoint,
  ) { }
  

searchProduct(lineas: string[], tipoPlan: string): Observable<any> {
    return this.httpClient
      .post<any>(this.apiCarnetPrograma, {
        lineaNegocios: lineas,
        tipoPlan: tipoPlan
      })
      .pipe(
        map((response) => response.data),
        catchError((error) => {
          console.error('Error en searchProduct: ', error);
          return throwError(
            () => new Error(error ? error.message : 'No se encontraron programas'),
          );
        }),
      );
  }

/*
  searchProduct(data: string[]): Observable<any> {
    const url = this.apiEndpoint.URL_PRODUCT_COOMEVA();
    return this.httpClient
      .post<any>(`${url}`, {
        programas: data,
      })
      .pipe(
        map((response) => response.data),
        catchError((error) => {
          console.error('Error en searchProduct: ', error);
          return throwError(
            () => new Error(error ? error : 'No se encontraron programas'),
          );
        }),
      );
  }
  */

  searchPeople(
    data: QuotationPeopleRequest,
  ): Observable<QuotationPeopleResponse> {
    data.codigoTipoPlan = 'F';
    data.codigoLineaNegocio = '2';
    const url = this.apiEndpoint.URL_PEOPLE_COOMEVA();
    return this.httpClient.post<any>(`${url}consultarDatosUsuario`, data).pipe(
      map((response: any) => response as QuotationPeopleResponse),
      catchError((error) => {
        console.error('Error en searchPeople: ', error);
        const errorMessage =
          error.error?.message ||
          'No se encontraron datos de usuario con la información ingresada';
        return throwError(() => new Error(errorMessage));
      }),
    );
  }

  searchContract(data: ContractRequest): Observable<ModelDefaultResponse<any>> {
    const url = this.apiEndpoint.URL_PEOPLE_COOMEVA();
    return this.httpClient.get<ModelDefaultResponse<any>>(
      `${url}consultarContratosActivos/${data.tipoDocumento}/${data.documento}`,
    );
  }

  getTypeDocument(): Observable<Array<documentType>> {
    const url = this.apiEndpoint.URL_SERVICE();
    return this.httpClient
      .get<ModelDefaultResponse<any>>(`${url}params/tipoDocumentos`)
      .pipe(
        map((response: any) => {
          return response as Array<documentType>;
        }),
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error ? error : 'Problema consultando tipo de documento',
              ),
          );
        }),
      );
  }

  bucarCampa(data: CampaniaRequest): Observable<any> {
    const url = `${environment.HOST}${URL_MAP.API.AFE}`; // Ajusta la URL según tu configuración

    return this.httpClient
      .post<ModelDefaultResponse<any>>(`${url}/cotizador/afe/campanias`, data)
      .pipe(
        map((response: ModelDefaultResponse<any>) => {
          let dat: any = response;
          let result: any[] = dat; // Ajusta según tus modelos
          return result;
        }),
        catchError((error) => {
          console.error('Error al buscar campañas:', error);
          return throwError(
            () =>
              new Error(
                error ? error.message : 'Error en la búsqueda de campañas',
              ),
          );
        }),
      );
  }

  bucarTarifa(data: IDataTarifa): Observable<ModelDefaultResponse<any>> {
    const url = `${environment.HOST}${URL_MAP.API.AFE}`;
    return this.httpClient.post<ModelDefaultResponse<any>>(
      `${url}/tarifas`,
      data,
    );
  }

  buscarTarifaSubscribe(data: IDataTarifa): Observable<any> {
    const url = this.apiEndpoint.URL_SERVICE_QUOTER();
    return this.httpClient.post<any>(`${url}cotizador/tarifas`, data);
  }

  buscarDescuentosSubscribe(): Observable<any> {
    const url = this.apiEndpoint.URL_SERVICE_QUOTER();
    return this.httpClient.get<any>(`${url}cotizador/descuentos`);
  }

  enviarCotizador(data: CampaniaRequest): Observable<any> {
    const url = this.apiEndpoint.URL_SERVICE_QUOTER();
    return this.httpClient
      .post<ModelDefaultResponse<any>>(`${url}cotizador/`, data)
      .pipe(
        map((response: ModelDefaultResponse<any>) => {
          return response;
        }),
        catchError((error) => {
          console.error('Error al enviar cotizador:', error);
          return throwError(
            () =>
              new Error(error ? error.message : 'Error al enviar cotización'),
          );
        }),
      );
  }

  guardarCotizacionSusbscribe(
    data: ModeloCotizacion,
  ): Observable<BodyResponse> {
    const url = this.apiEndpoint.URL_SERVICE_QUOTER();
    return this.httpClient.post<BodyResponse>(`${url}cotizador/save`, data);
  }

  enviarCotizacion(id: any) {
    const url = this.apiEndpoint.URL_SERVICE_QUOTER() + `cotizador/send/${id}`;
    return this.httpClient.get<ModelDefaultResponse<any>>(url).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  guardarCotizacion(
    data: ModeloCotizacion,
  ): Observable<ModelDefaultResponse<any>> {
    const url = this.apiEndpoint.URL_SERVICE_QUOTER();
    return this.httpClient.post<ModelDefaultResponse<any>>(
      `${url}cotizador/save`,
      data,
    );
  }

  obtenerTipoDocumento(): Observable<Array<documentType>> {
    const body = {
      nombreClave: 'getSpDocuTipos',
      jsonParametros: '{}',
    };

    return this.httpClient.post<any>(this.apiUrl, body).pipe(
      map((response) => {
        // 👉 Aquí está lo importante:
        // Tu backend devuelve GeneralResponse, no la lista directa

        if (!response || !response.status) {
          throw new Error(
            response?.message || 'Error consultando tipos de documento',
          );
        }

        return response.data as Array<documentType>;
      }),
      catchError((error) =>
        throwError(
          () =>
            new Error(
              error?.message || 'Problema consultando tipo de documento',
            ),
        ),
      ),
    );
  }

  consultarContratos(
    documento: string,
    tipoDocumento: string,
  ): Observable<Array<ContratosActivos>> {
    const body = {
      //nombreClave: 'getRFDusuarioMP',
      nombreClave: 'getConsultaContratoUsuario',
      jsonParametros: JSON.stringify({
        prm_docu_tipo: tipoDocumento,
        prm_docu_nro: documento,
      }),
    };

    return this.httpClient.post<any>(this.UrlContratos, body).pipe(
      map((response) => {
        if (!response || !response.status) {
          throw new Error(
            response?.message || 'Error consultando tipos de documento',
          );
        }

        return response.data as Array<ContratosActivos>;
      }),
      catchError((error) =>
        throwError(
          () =>
            new Error(
              error?.message ||
              'Problema consultando los contratos del usuario',
            ),
        ),
      ),
    );
  }

  public getCodigoAsesor(documento: string): Observable<any> {
    const body = {
      nombreClave: 'getSpAsesorDocumento',
      jsonParametros: JSON.stringify({ prm_docu_asesor: documento }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post<any>(this.urlCodigo_Asesor, body, httpOptions).pipe(
      map((response) => {
        if (response?.status && response?.data?.length > 0) {
          return response.data[0]; // <-- retornamos TODO el objeto
        } else {
          throw new Error('No se encontró asesor en la respuesta');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error al obtener el asesor:', error);
        return throwError(() => error);
      }),
    );
  }

  /**
   * Consulta datos de empresa (getDatosxEmpresa).
   * @param cuentaTipo Opcional: 'C' (Colectivo) o 'A' (Grupo de afinidad).
   *   Si se envía, solo se acepta la primera fila con ese cuenta_tipo; si no hay match → null.
   */
  public consultarDatosXEmpresa(
    tipo_documento: string,
    documento: string,
    cuentaTipo?: string,
  ): Observable<any> {

    const body = {
      nombreClave: 'getDatosxEmpresa',
      jsonParametros: JSON.stringify({ pty_tipo_documento: tipo_documento, pty_documento: documento }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post<any>(this.urlDatosxEmpresa, body, httpOptions).pipe(
      map((response) => {
        if (!response?.status) {
          throw new Error(response?.message || 'Error consultando datos de empresa');
        }
        const rows = Array.isArray(response?.data) ? response.data : [];
        const expected = (cuentaTipo ?? '').toString().trim().toUpperCase();
        const filtered = expected
          ? rows.filter(
              (r: any) =>
                (r?.cuenta_tipo ?? '').toString().trim().toUpperCase() === expected,
            )
          : rows;
        return filtered.length > 0 ? filtered[0] : null;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error al obtener datos de empresa:', error);
        return throwError(() => error);
      }),
    );

  }

  consutarRegionales(): Observable<Array<regional>> {
    const body = {
      nombreClave: 'getSpConsultaRegionales',
      jsonParametros: '{}',
    };

    return this.httpClient.post<any>(`${this.apiAfilmed}/regionales`, body).pipe(
      map((response) => {

        if (!response || !response.status) {
          throw new Error(
            response?.message || 'Error consultando regionales',
          );
        }

        return response.data as Array<regional>;
      }),
      catchError((error) =>
        throwError(
          () =>
            new Error(
              error?.message || 'Problema consultando regionales',
            ),
        ),
      ),
    );
  }

  consultarTiposDeAsesor(): Observable<Array<tiposDeAsesor>> {
    const body = {
      nombreClave: 'getTiposAsesor',
      jsonParametros: '{}',
    };

    return this.httpClient.post<any>(`${this.apiAfilmed}/tipoDeAsesor`, body).pipe(
      map((response) => {

        if (!response || !response.status) {
          throw new Error(
            response?.message || 'Error consultando tipos de asesor',
          );
        }

        return response.data as Array<tiposDeAsesor>;
      }),
      catchError((error) =>
        throwError(
          () =>
            new Error(
              error?.message || 'Problema consultando tipos de asesor',
            ),
        ),
      ),
    );
  }

  consultarCiudadesCem(): Observable<Array<ciudadesCem>> {
    const body = {
      nombreClave: 'getCotConsultarCiudadCem',
      jsonParametros: '{}',
    };

    return this.httpClient.post<any>(`${this.apiAfilmed}/ConsultarCiudadCem`, body).pipe(
      map((response) => {

        if (!response || !response.status) {
          throw new Error(
            response?.message || 'Error consultando ciudades CEM',
          );
        }

        return response.data as Array<ciudadesCem>;
      }),
      catchError((error) =>
        throwError(
          () =>
            new Error(
              error?.message || 'Problema consultando ciudades CEM',
            ),
        ),
      ),
    );
  }

  municipiosxDepartamento(departamento: string): Observable<any> {
    const body = {
      nombreClave: 'getSpMunicipiosXDeptoActivos',
      jsonParametros: JSON.stringify({ prm_departamento: departamento }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post<any>(`${this.apiAfeCotizadorUrl}/MunicipiosxDpto`, body, httpOptions).pipe(
      map((response) => {
        if (response?.status && response?.data?.length > 0) {
          return response.data; // <-- retornamos el array completo de municipios
        } else {
          throw new Error('No se encontraron municipios en la respuesta');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error al obtener municipios por departamento:', error);
        return throwError(() => error);
      }),
    );
  }

  consultarSectores(): Observable<sectoresCIIU[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient
      .get<GeneralResponse<sectoresCIIU[]>>(`${this.apiSectores}/sectores`, httpOptions)
      .pipe(
        map((response) => {
          if (response?.status && Array.isArray(response?.data)) {
            return response.data;
          }

          throw new Error(response?.message || 'Error al consultar sectores');
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error al obtener sectores:', error);
          return throwError(() => error);
        }),
      );
  }

  consultarSucursalesXRegional(regional: string): Observable<any> {
    const body = {
      nombreClave: 'getSucursalesxRegional',
      jsonParametros: JSON.stringify({ prm_regional: regional }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post<any>(`${this.apiAfilmed}/SucursalesXRegional`, body, httpOptions).pipe(
      map((response) => {
        if (response?.status && response?.data?.length > 0) {
          return response.data; // <-- retornamos el array completo de sucursales
        } else {
          throw new Error('No se encontraron sucursales en la respuesta');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error al obtener sucursales por regional:', error);
        return throwError(() => error);
      }
      ));
  }

  consultarAnexos(cuenta: string, subcta: string, plan_grupo: string): Observable<any> {
    const body = {
      nombreClave: 'getCotConsultarAnexosAfilmed',
      jsonParametros: JSON.stringify({ prm_cuenta: cuenta, prm_subcta: subcta, prm_plan_grupo: plan_grupo }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient
      .post<any>(`${this.apiAfeParms}`, body, httpOptions)
      .pipe(
        map((response) => {
          if (response?.status && response?.data?.length > 0) {
            return response.data;
          } else {
            throw new Error('No se encontraron Anexos');
          }
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error al obtener anexos:', error);
          return throwError(() => error);
        }),
      );
  }

  getconsultacolectivoac(documento: string, tipoDocumento: string, evaluador: string): Observable<any> {
    const body = {
      nombreClave: 'getconsultacolectivoac',
      jsonParametros: JSON.stringify({
        documento: documento,
        tipoDocumento: tipoDocumento,
        evaluador: evaluador,
      }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient
      .post<any>(`${this.apiAfilmed}/consultaActivoAc`, body, httpOptions)
      .pipe(
        map((response) => {
          if (response?.status !== true) {
            return [];
          }
          const data = response?.data;
          if (Array.isArray(data?.jsonRespuesta)) {
            return data.jsonRespuesta;
          }
          return Array.isArray(data) ? data : [];
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        }),
      );
  }

  guardarLiquidacionColectivo(data: LiquidacionColectivoRequest[]): Observable<LiquidacionColectivoResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient
      .post<LiquidacionColectivoResponse>(
        `${this.apiAfeLiquidacionColectivo}`,
        data,
        httpOptions,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error al guardar liquidación colectivo:', error);
          // Extraer el errorMessage de la respuesta del servidor si existe
          const errorMessage = error.error?.errorMessage || 
                              error.error?.message || 
                              error.message || 
                              'Error al guardar la liquidación colectiva';
          const customError = new Error(errorMessage);
          return throwError(() => customError);
        }),
      );
  }

  actualizarEstadoCotizacion(idCotizacion: number, idEstado: number = 2): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient
      .patch<any>(`${this.apiCotizacion}/${idCotizacion}/estado`, { idEstado }, httpOptions)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error al actualizar estado de cotización:', error);
          return throwError(() => error);
        }),
      );
  }

  descargarPdfCotizacionColectivo(
        idCotizacion: string,
        ciudadAsesor: string,
        porcentajeSubsidio: string,
        mostrarTodosEscenarios: boolean,
        aplicaAnexos: boolean,
        nombreJefe: string,
        cargoJefe: string
  ): Observable<Blob> {
    const body = {
      jsonParametros: JSON.stringify({
         P_ID_COTIZACION: idCotizacion, 
         P_CIUDAD_ASESOR: ciudadAsesor, 
         P_PORCENTAJE_SUBSIDIO: porcentajeSubsidio, 
         P_MOSTRAR_TODOS_ESCENARIOS: mostrarTodosEscenarios, 
         P_APLICA_ANEXOS: aplicaAnexos, 
         P_NOMBRE_JEFE: nombreJefe, 
         P_CARGO_JEFE: cargoJefe 
      }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
      responseType: 'arraybuffer' as 'json',
    };

    return this.httpClient
      .post<any>(this.apiPdfCotizacionColectivo, body, httpOptions)
      .pipe(
        map((response: any) => {
          const buffer = response as ArrayBuffer;

          if (!buffer || buffer.byteLength === 0) {
            throw new Error('El servicio retornó un PDF vacío');
          }

          return new Blob([buffer], { type: 'application/pdf' });
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error al descargar PDF cotización colectivo:', error);
          const errorMessage = error?.error?.message || error?.message || error.statusText || 'Error desconocido en descarga de PDF';
          return throwError(() => new Error(errorMessage));
        }),
      );
  }

  sincronizarLiquidacionColectivo(idCotizacion: number, data: LiquidacionColectivoRequest[]): Observable<LiquidacionColectivoResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };
    return this.httpClient
      .put<LiquidacionColectivoResponse>(
        `${environment.HOST}${URL_MAP.API.SINCRONIZAR_LIQUIDACION_COLECTIVO}/${idCotizacion}/sincronizar`,
        data,
        httpOptions,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error al sincronizar liquidación colectivo:', error);
          const errorMessage = error.error?.errorMessage || error.error?.message || error.message || 'Error al sincronizar la liquidación colectiva';
          return throwError(() => new Error(errorMessage));
        }),
      );
  }

  getLiquidacionColectivo(idCotizacion: number): Observable<LiquidacionColectivoResponse> {
    return this.httpClient
      .get<LiquidacionColectivoResponse>(
        `${this.apiObtenerLiquidacionColectivo}/${idCotizacion}`,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error al obtener liquidación colectivo:', error);
          return throwError(() => error);
        }),
      );
  }

  obtenerProgramasxEmpresa(documento: string, tipoDocumento: string): Observable<any> {
    const body = {
      nombreClave: 'getProgramasxEmpresa',
      jsonParametros: JSON.stringify({
        pty_tipo_documento: tipoDocumento,
        pty_documento: documento,
      }),
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient
      .post<any>(`${this.apiAfilmed}/getProgramasxEmpresa`, body, httpOptions)
      .pipe(
        map((response) => {
          if (response?.status && response?.data?.length > 0) {
            return response.data;
          } else {
            throw new Error('No se encontraron programas x empresa');
          }
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error al obtener programas:', error);
          return throwError(() => error);
        }),
      );
  }

  consultarCotizacionActiva(
    numeroDocumento: string
  ): Observable<any> {

    return this.httpClient.get(
      `${this.apiCotizacionActiva}/${numeroDocumento}`
    );
  }

  obtenerBrochuresPorProgramas(
    programas: string[],
  ): Observable<BrochureProgramaResponse[]> {
    const programasNormalizados = Array.from(
      new Set(
        (programas ?? [])
          .filter((programa) => !!programa?.trim())
          .map((programa) => programa.trim().toUpperCase()),
      ),
    );

    console.log('Programas recibidos en el servicio:', programas);
    console.log('Programas normalizados:', programasNormalizados);
    console.log('URL del servicio:', this.apiBrochuresProgramas);

    if (programasNormalizados.length === 0) {
      return of([]);
    }

    const request: BrochureProgramaRequest = {
      programas: programasNormalizados,
    };

    return this.httpClient
      .post<BrochureProgramaResponse[]>(
        this.apiBrochuresProgramas,
        request,
      )
      .pipe(
        map((response) => response ?? []),
        catchError((error: HttpErrorResponse) => {
          console.error(
            'Error al consultar brochures de los programas:',
            error,
          );

          const errorMessage =
            error.error?.message ||
            error.error?.errorMessage ||
            error.message ||
            'No fue posible consultar los brochures de los programas';

          return throwError(() => new Error(errorMessage));
        }),
      );
  }
}